<template>
  <div>
    <h3 class="text-base font-semibold text-gray-900">{{ $gettext("Statistiques (30 derniers jours)") }}</h3>
    <dl class="mt-5 grid grid-cols-1 gap-5 md:grid-cols-3">
      <div
        v-for="(item, index) in stats"
        :key="item.name"
        class="relative overflow-hidden rounded-xl bg-white px-5 py-6 shadow-sm ring-1 ring-gray-900/5 transition-shadow hover:shadow-md"
      >
        <dt>
          <div :class="[iconColors[index], 'absolute rounded-lg p-3']">
            <component :is="icons[index]" class="h-5 w-5 text-white" aria-hidden="true" />
          </div>
          <p class="ml-16 truncate text-sm font-medium text-gray-500">{{ item.name }}</p>
        </dt>
        <dd class="ml-16 flex items-baseline gap-2">
          <p class="text-3xl font-bold tracking-tight text-gray-900">{{ item.stat }}</p>
          <div :class="[
            item.changeType === 'increase' ? 'bg-green-50 text-green-700 ring-green-600/20' : 'bg-red-50 text-red-700 ring-red-600/20',
            'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset'
          ]">
            <ArrowUpIcon v-if="item.changeType === 'increase'" class="-ml-0.5 mr-0.5 h-3.5 w-3.5 text-green-600" aria-hidden="true" />
            <ArrowDownIcon v-else class="-ml-0.5 mr-0.5 h-3.5 w-3.5 text-red-600" aria-hidden="true" />
            {{ item.change }}%
          </div>
        </dd>
        <p class="ml-16 mt-1 text-xs text-gray-400">{{ item.previousStat }} {{ $gettext("il y a 30 jours") }}</p>
      </div>
    </dl>
  </div>
</template>

<script setup>
import { useStatisticStore } from "@/stores/statistic";
import { onMounted } from "vue";
import { storeToRefs } from "pinia";
import { ArrowDownIcon, ArrowUpIcon } from "@heroicons/vue/20/solid";
import { UsersIcon, HomeModernIcon, KeyIcon } from "@heroicons/vue/24/outline";

const statistics = useStatisticStore();
const { stats } = storeToRefs(statistics);

const icons = [UsersIcon, HomeModernIcon, KeyIcon];
const iconColors = ["bg-indigo-500", "bg-emerald-500", "bg-amber-500"];

onMounted(() => {
  statistics.fetchAll();
});
</script>
